/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.14.0
 * @since 1.14.0
 */

import styled from 'styled-components';

import { fonts } from '../../../../theme';

export const WizardChangeLockStyled = styled.div.attrs({
    className: 'wizard-change-lock',
})`
    margin-top: 32px;

    .wizard-change-lock__title {
        margin-top: 4px;
        margin-bottom: 4px;
        ${fonts.textMainBold}
    }

    .wizard-change-lock__radio-button {
        margin-top: 24px;
    }

    .wizard-change-lock__info-block {
        margin-top: 32px;
        max-width: 690px;
    }
`;

export const StepSelectDateFilterStyled = styled.div.attrs(() => ({
    className: 'step-select-date__filter',
}))`
    width: 275px;

    &:nth-child(2) {
        margin-top: 24px;
    }

    .select-container,
    .drop-down-filter__filter-button {
        height: 48px;
    }
`;
